import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'proxy-polyfill';
import 'core-js/stable';
import 'isomorphic-fetch';
import 'date-input-polyfill';
import 'intersection-observer';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './styles/highlight-share.css';
import './styles/bootstrap.min.css';
import './styles/formio.full.min.css';
import { runOidcBootstrap } from './oidcBootstrap';

// The OIDC bootstrap must finish before react-admin's auth checks run: a `?code` exchange has to
// have stored its tokens (and BASIC_INFO) by first render, and a silent-login redirect makes
// rendering pointless. It resolves immediately on every path that needs no OIDC work.
//
// App is imported dynamically, not statically: its module scope starts analytics and Sentry
// (session replay and tracing both record the page URL), so nothing from that graph may evaluate
// until the bootstrap has exchanged and scrubbed any one-time `?code` credential from the URL.
runOidcBootstrap().then(async () => {
    const { default: App } = await import('./App');

    ReactDOM.render(<App />, document.getElementById('root'));
});
